/**
 * Etichette e toni UI della documentazione video (pagina /documentazione).
 * Solo presentazione: i valori canonici vivono in `types/videoDocs.ts`.
 */

import type { SoftChipTone } from '../SoftChip';
import type { VideoDocStato } from '../../types/videoDocs';

/** Ordine canonico degli stati (usato per select e menu cambio stato). */
export const STATO_VIDEO_ORDER: VideoDocStato[] = ['attuale', 'da_aggiornare', 'obsoleto'];

export const STATO_VIDEO_LABELS: Record<VideoDocStato, string> = {
  attuale: 'Attuale',
  da_aggiornare: 'Da aggiornare',
  obsoleto: 'Obsoleto',
};

/** Toni chip: attuale=verde, da_aggiornare=ambra, obsoleto=grigio. */
export const STATO_VIDEO_TONES: Record<VideoDocStato, SoftChipTone> = {
  attuale: 'success',
  da_aggiornare: 'warning',
  obsoleto: 'default',
};

/** Descrizione della visibilità tenant per stato (mostrata nei tooltip/menu). */
export const STATO_VIDEO_HINTS: Record<VideoDocStato, string> = {
  attuale: 'visibile ai tenant',
  da_aggiornare: 'visibile con avviso "alcune schermate potrebbero differire"',
  obsoleto: 'mai visibile ai tenant',
};

/** Durata video leggibile (es. "12:05", "1:03:12"); '—' se assente. */
export function formatDurataVideo(seconds?: number): string {
  if (typeof seconds !== 'number' || !Number.isFinite(seconds) || seconds < 0) return '—';
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.round(seconds % 60);
  const mm = h > 0 ? String(m).padStart(2, '0') : String(m);
  const ss = String(s).padStart(2, '0');
  return h > 0 ? `${h}:${mm}:${ss}` : `${mm}:${ss}`;
}
